/*
 * Copyright (C) 2023 Nick Robinson
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

package uk.co.nickthecoder.glok.theme

import uk.co.nickthecoder.glok.property.StylableProperty
import uk.co.nickthecoder.glok.util.log
import uk.co.nickthecoder.glok.util.simpleName
import kotlin.reflect.KClass

/**
 */
actual fun findStylableProperty(
    node: Styled,
    valueType: KClass<*>,
    propertyName: String,
    selector: Selector
): StylableProperty<*>? {
    val result = node.getStylableProperties().firstOrNull { it.beanName == propertyName }
    if (result == null) {
        log.warn("Stylable property $propertyName not found (${node.simpleName()})")
    }
    return result
}
